// @flow

import { APP_WILL_MOUNT, APP_WILL_UNMOUNT } from '../base/app';
import { CONFERENCE_JOINED } from '../base/conference';
import { PARTICIPANT_JOINED } from '../base/participants';
import { MiddlewareRegistry } from '../base/redux';
import { playSound, stopSound, registerSound, unregisterSound } from '../base/sounds';

import { RING_TONE_SOUND_ID, BEEP_TONE_SOUND_ID } from './constants';
import { RING_TONE_SOUND_FILE, BEEP_TONE_SOUND_FILE } from './sounds';

MiddlewareRegistry.register(store => next => action => {
    const result = next(action);

    switch (action.type) {
    case APP_WILL_MOUNT:
        store.dispatch(registerSound(RING_TONE_SOUND_ID, RING_TONE_SOUND_FILE));
        store.dispatch(registerSound(BEEP_TONE_SOUND_ID, BEEP_TONE_SOUND_FILE));
        break;
    case APP_WILL_UNMOUNT:
        store.dispatch(unregisterSound(RING_TONE_SOUND_ID));
        store.dispatch(unregisterSound(BEEP_TONE_SOUND_ID));
        break;
    case PARTICIPANT_JOINED: {
        store.dispatch(stopSound(BEEP_TONE_SOUND_ID));
        const { room } = store.getState()['features/base/conference'];

        sessionStorage.removeItem(`ringing-${room}`);
        sessionStorage.removeItem(`ringing-${room}-firstName`);
        break;
    }
    }

    return result;
});
